import React from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import useUsersApi from '../hooks/users/useUsersApi'
import UserForm from '../components/users/UserForm'

export default function CreateUserPage({ building }) {
  const history = useHistory()
  const location = useLocation()
  const [_, methods] = useUsersApi()

  const {
    selectedBuilding,
    selectedApartment,
    selectedUserType,
    search,
    user,
    previousRoute,
  } = location.state || {}

  const getParams = () => {
    let params = {}
    params.buildingId = selectedBuilding?.id || building?.id
    if (selectedApartment?.id) params.apartmentId = selectedApartment?.id
    if (selectedUserType) params.type = selectedUserType
    if (search) params.search = search
    return params
  }

  return (
    <UserForm
      onSubmit={(values) => {
        if (values.id) {
          methods.updateUser(values, getParams())
        } else {
          methods.createUser(values)
        }
        history.push(previousRoute)
      }}
      handleCancel={() => history.push(previousRoute)}
      user={user}
      building={building}
    />
  )
}
